/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../../../../../resources/theme/global'

import ServiceTypesFilter from './Filter'
import ServiceTypesTable from './Table'
import { Grid, Typography, withStyles } from '@material-ui/core'
import BaseCreatePage from '../../../../../components/hooks/BaseCreatePage'
import { edit } from '../../PartnersActions'

const ServiceTypes = props => {
  const [onlyActive, setOnlyActive] = useState(false)
  const dispatch = useDispatch()
  const editingLaundry = useSelector(state => state.laundries.editingLaundry)
  const editingId = props.match.params.id

  useEffect(() => {
    if (!editingId) return
    dispatch(edit(editingId))
  }, [editingId])

  return (
    <BaseCreatePage
      page="Tipos de Serviço"
      path={editingLaundry.name}
      hiddenReturn
      goBack
    >
      <Grid container item xs={12} spacing={2} style={{ marginTop: '1em' }}>
        <Grid item xs={12}>
          <ServiceTypesFilter
            onlyActive={onlyActive}
            editingId={editingId}
            onToggleActive={() => setOnlyActive(prev => !prev)}
          />
        </Grid>

        <Grid item xs={12}>
          <ServiceTypesTable
            onlyActiveItems={onlyActive}
            editingId={editingId}
          />
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default withStyles(styles)(ServiceTypes)
